import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/fridge_open.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-ca856972")

_pushScopeId("data-v-ca856972")
const _hoisted_1 = { class: "dialog-overlay" }
const _hoisted_2 = { class: "dialog-display-area" }
const _hoisted_3 = { class: "dialog-box" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-title" }, [
  /*#__PURE__*/_createVNode("span", { class: "dialog-box-title-text" }, "設定を受け付けました")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-spacer" }, null, -1)
const _hoisted_6 = { class: "dialog-box-contents" }
const _hoisted_7 = { class: "dialog-box-contents-contents" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-spacer" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-contents-messageimage-image" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "dialog-box-contents-messageimage-image-image",
    src: _imports_0
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-spacer" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-spacer" }, null, -1)
const _hoisted_12 = { class: "dialog-box-bottom" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "dialog-box-bottom-negative-text" }, "OK", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "dialog" }, {
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", {
                    class: "dialog-box-contents-text",
                    innerHTML: _ctx.MESSAGE_TOP
                  }, null, 8, ["innerHTML"]),
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode("div", {
                    class: "dialog-box-contents-text",
                    innerHTML: _ctx.MESSAGE_BOTTOM
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _hoisted_11,
              _createVNode("div", _hoisted_12, [
                _createVNode("div", {
                  class: "dialog-box-bottom-negative",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickButton(...args)))
                }, [
                  _hoisted_13
                ])
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowDialog]
        ])
      ]),
      _: 1
    })
  ]))
})